import { ApiClient } from '../../../../infra';
/**
 * O que o ICP pede ao servidor.
 *
 * Tres perguntas, e so esta tela as faz. As tres sao do administrador geral
 * (`ROLE_ADMIN` no servidor), e todas as datas da resposta sao DIAS - nao ha instante
 * para converter.
 */
export class IcpApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new IcpApi(); }
    /** A visao geral: indicadores, perfil ideal, comparacao e metodologia. */
    async fetchOverview(filter, signal) {
        return (await this.client.send('GET', `/icp/overview?${queryOf(filter)}`, undefined, signal));
    }
    /** O scorecard: uma linha por empresa ativa no recorte. */
    async fetchCompanies(filter, signal) {
        return (await this.client.send('GET', `/icp/companies?${queryOf(filter)}`, undefined, signal));
    }
    /**
     * A persona agregada. So a janela vale aqui: a persona compara as pessoas das empresas
     * com as sem empresa, e segmento e porte sao recortes de empresa.
     */
    async fetchWorkforce(windowDays, signal) {
        return (await this.client.send('GET', `/icp/workforce?windowDays=${windowDays}`, undefined, signal));
    }
}
/** So vai na consulta o filtro que existe: parametro vazio o servidor leria como valor. */
function queryOf(filter) {
    const query = new URLSearchParams({ windowDays: String(filter.windowDays) });
    if (filter.segmentId !== undefined) {
        query.set('segmentId', String(filter.segmentId));
    }
    if (filter.sizeBand !== undefined) {
        query.set('sizeBand', filter.sizeBand);
    }
    return query.toString();
}
//# sourceMappingURL=icp.api.js.map